//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';
import tableConfig from './tableConfig';
import StatisticsTradeTransactionsFilters from './StatisticsTradeTransactionsFilters.vue';
import StatisticsTradeTransactionsChart from './StatisticsTradeTransactionsChart.vue';

export default {
  components: {
    StatisticsTradeTransactionsFilters,
    StatisticsTradeTransactionsChart,
  },
  data() {
    return {
      constant,
      tableConfig,
      loader: false,
      amount: [
        {
          currencyId: 1,
          currencyTitle: 'USD',
          amount: 0,
          fee: 0,
          equivalentAmount: 0,
          equivalentFee: 0,
          equivalentCurrencyId: 0,
          equivalentCurrencyTitle: 'USD',
        },
        {
          currencyId: 2,
          currencyTitle: 'EURO',
          amount: 0,
          fee: 0,
          equivalentAmount: 0,
          equivalentFee: 0,
          equivalentCurrencyId: 0,
          equivalentCurrencyTitle: 'USD',
        },
        {
          currencyId: 3,
          currencyTitle: 'RUB',
          amount: 0,
          fee: 0,
          equivalentAmount: 0,
          equivalentFee: 0,
          equivalentCurrencyId: 0,
          equivalentCurrencyTitle: 'USD',
        },
      ],
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapState('statisticsTradeTurnoverTransactions', ['chartData']),
  },

  async created() {
    this.setGeneralProgress(true);
    this.loader = true;
    await Promise.allSettled([
      this.loadDataAction(),
    ]);
    this.loader = false;
    this.setGeneralProgress(false);
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('statisticsTradeTurnoverTransactions', {
      loadDataAction: 'loadData',
    }),
    async loadData() {
      await this.loadDataAction();
    },
    async applyFilters() {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.loadDataAction();
      await this.loadChartAction();
      this.setGeneralProgress(false);
      this.loader = false;
    },
  },
};
